/**
 * Чистые помощники консультантского экрана — свёртка дерева, поиск, честные
 * формулировки возраста данных.
 *
 * Вынесены из страницы отдельным модулем сознательно: страница тянет AppShell
 * и карту, а эти решения хочется проверять тестом без браузерного окружения —
 * они ломаются молча и видны пользователю как «система врёт».
 */
import type { ClientTreeNode } from './types';

/**
 * Раскрыть верхний уровень дерева отделов — свёрнутое дерево на первом экране
 * это лишний клик до любой работы.
 */
export function topLevelIds(nodes: ClientTreeNode[]): string[] {
  return nodes.map((n) => n.id);
}

/**
 * Подпись пагинатора. Показываем ДИАПАЗОН, а не только номер страницы:
 * «51–100 из 11 244» отвечает на вопрос «где я и сколько ещё», а «стр. 2»
 * не отвечает ни на один.
 */
export function pageRangeLabel(
  page: number,
  perPage: number,
  total: number,
): string {
  if (total === 0) return 'ничего не найдено';
  const from = (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);
  return `${from}–${to} из ${total.toLocaleString('ru')}`;
}

/**
 * Возраст данных словами. Считается от `synced_at` ИСТОЧНИКА — продавец
 * должен понимать, свежий ли перед ним список, иначе «клиента нет в системе»
 * читается как поломка системы, а не как «синхронизация не прошла».
 */
export function syncAgeLabel(syncedAt: string | null, now = Date.now()): string {
  if (!syncedAt) return 'Время синхронизации неизвестно';
  const ts = Date.parse(syncedAt);
  if (Number.isNaN(ts)) return 'Время синхронизации неизвестно';
  const minutes = Math.max(0, Math.round((now - ts) / 60000));
  if (minutes < 1) return 'Синхронизировано только что';
  if (minutes < 60) return `Синхронизировано ${minutes} мин назад`;
  const hours = Math.round(minutes / 60);
  return `Последняя синхронизация ${hours} ч назад`;
}

/** Дата последнего снимка словами. Пусто — честное «снимков пока нет». */
export function lastSceneLabel(iso: string | null, now = Date.now()): string {
  if (!iso) return 'Снимков пока нет';
  const ts = Date.parse(iso);
  if (Number.isNaN(ts)) return 'Снимков пока нет';
  const days = Math.floor((now - ts) / 86_400_000);
  if (days <= 0) return 'Последний снимок: сегодня';
  if (days === 1) return 'Последний снимок: вчера';
  return `Последний снимок: ${days} дн. назад`;
}
